import { NavLink } from 'react-router-dom';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../components/ui/tooltip';
import { Lock } from 'lucide-react';

const SidebarNavItem = ({ to, icon: Icon, label, locked = false, end = false, onNavigate }) => {
  if (locked) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="sidebar-item opacity-50 cursor-not-allowed" data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}-locked`}>
              <Icon className="w-5 h-5" />
              <span>{label}</span>
              <Lock className="w-3 h-3 ml-auto text-gray-400" />
            </div>
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>Upgrade subscription to access</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <NavLink
      to={to}
      end={end}
      onClick={onNavigate}
      className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
      data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Icon className="w-5 h-5" />
      <span>{label}</span>
    </NavLink>
  );
};

export default SidebarNavItem;
